/**
 * Hold chart layout state
 */
import { UPDATE_CHART_LAYOUT } from '../actions/chart_picker';

export interface IChartPickerSelection {
  cols: number;
  rows: number
}
export interface IChartPicker{
  selected: IChartPickerSelection
}

const defaultState = {
  selected: {
    cols: 1,
    rows: 1
  }
};

const chartPicker = (state: IChartPicker = defaultState, action: any) => {
  switch (action.type) {
  case UPDATE_CHART_LAYOUT:
    return {
      selected: action.payload
    };
  default:
    return state;
  }
};

export default chartPicker;